import React from 'react'
import { Alert } from 'hhsoig-design-system-core'

export const Identity = () => {
  return (
    <div>
      <h1 className="ds-u-font-size--h2">Your identity</h1>
      <p>
        We recognize that you may want to maintain your confidentiality when
        filing a whistleblower retaliation complaint. Below are the options
        available to you and the impact each will have on your complaint.
      </p>
      <h2 className="ds-u-font-size--h3">
        No Restrictions: Disclose identity to OIG, HHS and others
      </h2>
      <p>
        You provide us your identifying information (name, address, etc.) when
        filing the online submission form. If it is determined that individuals
        and/or entities outside of HHS-OIG need to know the information, we can
        disclose your identity to them.
      </p>
      <Alert heading="Revocation of consent">
        If you opt to disclose your identity via the online submission process,
        you can still revoke it later if an agent is assigned to your case and
        contacts you. HHS-OIG reserves the right to close the investigation if
        lack of consent, or lack of cooperation from the complainant, results in
        an inability to thoroughly review and/or resolve the complaint’s
        allegations.
      </Alert>
      <h2 className="ds-u-font-size--h3">
        Confidential: Disclose identity to HHS-OIG only
      </h2>
      <p>
        You provide us your identifying information (name, address, etc.) when
        filing the online submission form, but request that we not share this
        information with individuals or entities outside of HHS-OIG. This option
        will hinder our ability to thoroughly review and/or resolve the
        complaint.
      </p>
      <Alert heading="Confidentiality">
        Despite a request for confidentiality, it may still be necessary to
        disclose your identity to individuals outside of HHS-OIG if HHS-OIG
        deems such disclosure is (1) necessary during the course of HHS-OIG’s
        investigation of the complaint’s allegations or (2) otherwise required
        by law.
      </Alert>
      <h2 className="ds-u-font-size--h3">Anonymous: Keep identity anonymous</h2>
      <p>
        You opt not to provide any identifying information (name, address, etc.)
        in the online submission complaint. You should know, however, that
        opting to remain anonymous precludes HHS-OIG from investigating a
        complaint as a whistleblower retaliation complaint and may hinder
        HHS-OIG from thoroughly reviewing and/or resolving the complaint’s
        allegations. There may be instances where for public safety, crime
        prevention, or other lawful purpose, HHS-OIG may need to trace your
        identity.
      </p>
    </div>
  )
}
